export default __webpack_public_path__ + "static/media/catAndManChilling.4ec835d2.png";